'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Thumbnail = require('@narvar/nth-bit-thumbnail');
var ItemCardClaims = require('../../../components/ItemCardClaims.js');
var useIsMobile = require('../../../providers/useIsMobile.js');
var ClaimSummaryComment = require('../components/ClaimSummaryComment.js');
var ClaimSummaryDetailsContainer = require('../components/ClaimSummaryDetailsContainer.js');
var ItemClaimSummaryProvider = require('./ItemClaimSummaryProvider.js');
var ClaimSummaryEstimatedAmount = require('../components/ClaimSummaryEstimatedAmount.js');
var Box = require('../../../components/layout/Box/Box.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Thumbnail__default = /*#__PURE__*/_interopDefaultLegacy(Thumbnail);

const AdditionalDetails = _ref => {
  let {
    claimDetails
  } = _ref;
  const {
    photos,
    additionalInfo: {
      comment
    }
  } = claimDetails;
  return /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 2,
    style: {
      marginTop: '0.5rem'
    }
  }, comment && /*#__PURE__*/React__default["default"].createElement(ClaimSummaryComment["default"], {
    comment: comment
  }), photos !== null && photos !== void 0 && photos.length ? /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 2,
    style: {
      flexDirection: 'row',
      flexWrap: 'wrap'
    }
  }, photos.map(photo => /*#__PURE__*/React__default["default"].createElement(Thumbnail__default["default"], {
    alt: photo.file.name,
    src: photo.objectUrl,
    key: photo.objectUrl,
    s: {
      width: '3.5rem',
      margin: 0,
      borderRadius: 0
    }
  }))) : null);
};
const ItemClaimSummaryDetails = () => {
  const isMobile = useIsMobile["default"]();
  const {
    itemSummaries
  } = ItemClaimSummaryProvider.useItemClaimSummary();
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(ClaimSummaryDetailsContainer["default"], null, itemSummaries.map(_ref2 => {
    let {
      itemClaimUid,
      itemClaim,
      itemDetails
    } = _ref2;
    return /*#__PURE__*/React__default["default"].createElement(ItemCardClaims["default"], {
      key: itemClaimUid,
      claimDetails: itemClaim,
      itemDetails: itemDetails,
      s: isMobile ? {
        alignItems: 'flex-start'
      } : undefined,
      additionalDetails: /*#__PURE__*/React__default["default"].createElement(AdditionalDetails, {
        claimDetails: itemClaim
      })
    });
  })), /*#__PURE__*/React__default["default"].createElement(ClaimSummaryEstimatedAmount["default"], null));
};

exports["default"] = ItemClaimSummaryDetails;
